import { message } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { convertServiceProviderListToDropdown } from "../../Helpers/ServiceProviderHelpers";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { apiCallback } from "../../ApiHandlers/Common";
import MainPage from "../MainPage";
import { DeviceActions, NavMenuItems } from "../../Constants/Constants";
import BulkAddDevice from "../Device/BulkAddDevice";
import ListOrders from "./ListOrder";

class Orders extends Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.orderManagement.icon()}
        <span>{NavMenuItems.orderManagement.label}</span>
      </>,
    ];
    this.state = {
      providerdata: [],
      providerDataLoading: false,
      selectedProvider: null,
      selectedProoviderName: null,
      action: null,
      record: null,
      orders: true,
    };
  }
  componentDidMount() {
    this.updateProviderList();
  }
  updateProviderList = () => {
    const { history, serviceProviderApi } = this.props;
    this.setState({ providerDataLoading: true });

    const errorCallback = (error) => {
      this.setState({ providerDataLoading: false });
      message.error("Error Fetching Provider List");
    };

    const successCallback = (data) => {
      const providerData = convertServiceProviderListToDropdown(data);
      this.setState({ providerData, providerDataLoading: false });
    };
    try {
      serviceProviderApi.getServiceprovider(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  onProviderSelect = (id, value) => {
    if (value) {
      this.setState({
        selectedProvider: id,
        selectedProviderName: value.children,
      });
    } else {
      this.setState({ selectedProviderName: null, selectedProvider: null });
    }
  };
  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };
  onSubmit = ({ redirect = true } = {}) => {
    redirect && this.setState({ action: null, record: null });
  };
  render() {
    const { deviceModelRecord } = this.props;
    const {
      providerData,
      providerDataLoading,
      selectedProvider,
      selectedProviderName,
      action,
      orders,
    } = this.state;
    return (
      <MainPage>
        <div>
          {!action ? (
            <ListOrders
              providerData={providerData}
              providerDataLoading={providerDataLoading}
              selectedProvider={selectedProvider}
              onProviderSelect={this.onProviderSelect}
              onActionClick={this.onActionClick}
              selectedProviderName={selectedProviderName}
              parentBread={this.header}
            />
          ) : action === DeviceActions.bulkAdd ? (
            <BulkAddDevice
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              deviceModelRecord={deviceModelRecord}
              orders={orders}
              parentBread={this.header}
            />
          ) : null}
        </div>
      </MainPage>
    );
  }
}
Orders.propTypes = {
  serviceProviderApi: PropTypes.object,

  providerData: PropTypes.array,
  providerDataLoading: PropTypes.bool,
  selectedProvider: PropTypes.string,
  deviceModelRecord: PropTypes.object,
  orders: PropTypes.bool,
  onProviderSelect: PropTypes.func,
  selectedProoviderName: PropTypes.string,
  onActionClick: PropTypes.func,
};
const mapStateToProps = (state) => ({
  serviceProviderApi: state.apis.serviceProviderApi,
});
const connectedOrders = connect(mapStateToProps)(Orders);
export default withRouter(connectedOrders);
